<template>
  <div>
    <CollectionView searchable :endpoint="utilities.path('communities/@/players/identifiers', communityId)" v-model:reload="reload">
      <template v-slot:header>
        <h4 class="mb-0">{{ translate("identifiers") }}</h4>
      </template>
      <template v-slot:content="{ items }">
        <div class="card">
          <div class="table-responsive">
            <div class="table">
              <div class="table-header">
                <div class="table-header-cell">{{ translate("value") }}</div>
                <div class="table-header-cell">{{ translate("type") }}</div>
                <div class="table-header-cell">{{ translate("created_at") }}</div>
              </div>
              <div class="table-body">
                <a class="table-row" v-for="item in items" :key="item.id" @click="viewId = item.id">
                  <div class="table-column">
                    {{ item.value }}
                  </div>
                  <div class="table-column">
                    <i :class="item.type.icon" class="fa-fw fa-lg"></i> <span class="fw-bold ms-2">{{ item.type.title }}</span>
                  </div>
                  <div class="table-column">{{ utilities.formatDatetime(item.createdAt) }}</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CollectionView>
    <ModalView :active="viewId !== undefined" @update:active="viewId = undefined">
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between">
          <h3 class="mb-0">{{ translate("identifier") }}</h3>
          <ModalCloseButtonView @click="viewId = undefined"/>
        </div>
      </template>
      <template v-slot:body>
        <PlayerIdentifierDetailsView :identifier-id="viewId"/>
      </template>
    </ModalView>
  </div>
</template>

<script setup>
import PlayerIdentifierDetailsView from "@/systems/modules/players/identifiers/PlayerIdentifierDetailsView.vue";
import {ButtonView, CollectionView, utilities, ModalView, ModalCloseButtonView} from "@/niftybit";
import {ref} from "vue";

defineProps({
  communityId: String
});

const reload = ref(false);
const viewId = utilities.routeQueryParam("viewId");

</script>